export default import.meta.ROLLUP_FILE_URL_2tYj3_Z_l5THUB3WLdNV5Q